<!-- Print Label UI-->
<div class="barcode-label" id="barcodeLabel" *ngIf="oId">
  <div>
    <span class="field"></span> <span id="patientId" class="patientIdValue">{{pId ? pId : 'S2J3TAY3TY'}}</span>
  </div>
  <div>
    <span class="field">YOB:</span> <span id="yob">{{yob}}</span>
  </div>
  <div>
    <span class="field">DOS:</span> <span id="dos">{{dos}}</span>
  </div>
  <div>
    <div id="barcode" class="barcode"></div>
    <!-- 1D CODE128 barcode used this element (kept for rollback): <svg id="barcode" class="barcode"></svg> -->
  </div>
</div>
<div class="p-3 hide-print">
  <button mat-flat-button color="warn" class="small-button px-0" (click)="closePrint()">
    Close
  </button>
</div>